/**
 * Report-Definition für die Zeiten-Seite (Standalone).
 */
import {
  buildDocument,
  buildSection,
  keyValuesBlock,
  kv,
  textBlock,
  type ReportDocument,
} from '../../../lib/pdf/reportModel';

export interface ZeitenReportInput {
  zeitenStart: string | null;
  zeitenEnde: string | null;
  zeitenPflichttermine: string;
  zeitenBeschraenkungen: string;
}

/** 'YYYY-MM-DD' -> 'DD.MM.YYYY'; leere/ungültige Werte -> ''. */
function formatDate(iso: string | null): string {
  if (!iso) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : iso;
}

export function buildZeitenReport(input: ZeitenReportInput): ReportDocument {
  return buildDocument([
    buildSection('Zeiten', [
      keyValuesBlock([
        kv('Frühester Projektstart', formatDate(input.zeitenStart)),
        kv('Spätestes Projektende', formatDate(input.zeitenEnde)),
      ]),
      textBlock('Pflichttermine', input.zeitenPflichttermine),
      textBlock('Beschränkungen', input.zeitenBeschraenkungen),
    ]),
  ]);
}
